<template>
	<div class="text-end"><span class="required_field"></span><b> = Required Field</b></div>
</template>
